import { styled } from '@clickcease/cc-client-components-lib'
import * as Collapsible from '@radix-ui/react-collapsible'

export const PlanFeaturesSectionStyled = styled(Collapsible.Root, {
  all: 'unset',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '$lg',
  marginBottom: '$16',
  width: '100%',

  '@bp1': {
    alignItems: 'center',
    marginBottom: '$8',
  },
})

export const PlanFeaturesSectionHeader = styled(Collapsible.Trigger, {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  width: 'calc(100% - 17px)',
  height: '66px',
  paddingLeft: '17px',
  lineHeight: '66px',
  borderRadius: '10px',
  fontWeight: '$sb',
  fontSize: '$h3',
  marginBottom: '$6',
  background: 'rgba(136, 179, 231, 0.10)',

  '@bp1': {
    width: '90%',
    height: '46px',
    lineHeight: '46px',
    borderRadius: '4px',
    justifyItems: 'space-between',
    alignItems: 'center',
  },
})

export const PlanFeaturesSectionContent = styled(Collapsible.Content, {
  all: 'unset',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})
